import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import EscalafonBody from '../components/municipalidad/EscalafonBody';

const Escalafon = () => (
  <div className='MainMunicipio'>
    <EscalafonBody />
  </div>
);
export default Escalafon;
